/* eslint-disable max-len */

import { IconButton } from "@mui/material";
import { useListContext, useTranslate } from "react-admin";
import { DateRange } from "@mui/x-date-pickers-pro";
import { Dayjs } from "dayjs";
import { ArrowLeftIcon, ArrowRightIcon } from "assets/Icons";

interface AppointmentDatesSelectButtonProps {
  dateValue: DateRange<Dayjs>;
  setDateValue: React.Dispatch<React.SetStateAction<DateRange<Dayjs>>>;
  handleDatePopoverClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  fromOrderList?: boolean;
}

const AppointmentDatesSelectButton = ({
  dateValue,
  setDateValue,
  handleDatePopoverClick,
  fromOrderList = false
}: AppointmentDatesSelectButtonProps) => {
  const { setFilters, filterValues } = useListContext();
  const translate = useTranslate();

  const dateDiff =
    dateValue?.[0] &&
    dateValue?.[1] &&
    dateValue?.[1].diff(dateValue?.[0], "day");

  return (
    <div className="flex bg-[#FAF9F7] border border-[rgba(48,47,46,0.23)] rounded-[32px]">
      <IconButton
        sx={{
          borderRadius: "0px",
          borderTopLeftRadius: "32px",
          borderBottomLeftRadius: "32px"
        }}
        className="border-none p-[0px] w-[36px] h-[34px] font-['Inter'] font-[500] text-[14px] text-mono-primaryTextColor"
        onClick={() => {
          if (
            dateValue?.[0] &&
            dateValue?.[1] &&
            (dateDiff || dateDiff === 0)
          ) {
            setDateValue([
              dateValue?.[0]?.subtract(dateDiff + 1, "day")?.startOf("day"),
              dateValue?.[1]?.subtract(dateDiff + 1, "day")?.endOf("day")
            ]);
            fromOrderList
              ? setFilters(
                  {
                    ...filterValues,
                    created_at: {
                      gte: dateValue?.[0]
                        ?.subtract(dateDiff + 1, "day")
                        ?.startOf("day")
                        ?.toISOString(),
                      lte: dateValue?.[1]
                        ?.subtract(dateDiff + 1, "day")
                        ?.endOf("day")
                        ?.toISOString()
                    }
                  },
                  undefined
                )
              : setFilters(
                  {
                    ...filterValues,
                    start_time: dateValue?.[0]
                      ?.subtract(dateDiff + 1, "day")
                      ?.startOf("day")
                      ?.toISOString(),
                    end_time: dateValue?.[1]
                      ?.subtract(dateDiff + 1, "day")
                      ?.endOf("day")
                      ?.toISOString()
                  },
                  undefined
                );
          }
        }}
        disabled={dateValue?.[0] === null || dateValue?.[1] === null}
      >
        <ArrowLeftIcon />
      </IconButton>
      <button
        className="border-none h-[34px] flex justify-center px-[6px] md:px-[12px] items-center font-['Inter'] font-[500] text-[12px] md:text-[14px] text-mono-primaryTextColor hover:bg-[rgba(0,0,0,0.04)]"
        onClick={handleDatePopoverClick}
      >
        {dateValue?.[0] !== null && dateValue?.[1] !== null
          ? dateDiff === 0
            ? `${dateValue?.[0].format("MMM D YYYY")}`
            : `${dateValue?.[0].format("MMM D YYYY")}-${dateValue?.[1].format(
                "MMM D YYYY"
              )}`
          : translate("common.select_date")}
      </button>
      <IconButton
        sx={{
          borderRadius: "0px",
          borderTopRightRadius: "32px",
          borderBottomRightRadius: "32px"
        }}
        className="border-none p-[0px] w-[36px] h-[34px] font-['Inter'] font-[500] text-[14px] text-mono-primaryTextColor"
        onClick={() => {
          if (
            dateValue?.[0] &&
            dateValue?.[1] &&
            (dateDiff || dateDiff === 0)
          ) {
            setDateValue([
              dateValue?.[0].add(dateDiff + 1, "day")?.startOf("day"),
              dateValue?.[1].add(dateDiff + 1, "day")?.endOf("day")
            ]);
            fromOrderList
              ? setFilters(
                  {
                    ...filterValues,
                    created_at: {
                      gte: dateValue?.[0]
                        .add(dateDiff + 1, "day")
                        ?.startOf("day")
                        ?.toISOString(),
                      lte: dateValue?.[1]
                        .add(dateDiff + 1, "day")
                        ?.endOf("day")
                        ?.toISOString()
                    }
                  },
                  undefined
                )
              : setFilters(
                  {
                    ...filterValues,
                    start_time: dateValue?.[0]
                      .add(dateDiff + 1, "day")
                      ?.startOf("day")
                      ?.toISOString(),
                    end_time: dateValue?.[1]
                      .add(dateDiff + 1, "day")
                      ?.endOf("day")
                      ?.toISOString()
                  },
                  undefined
                );
          }
        }}
        disabled={dateValue?.[0] === null || dateValue?.[1] === null}
      >
        <ArrowRightIcon />
      </IconButton>
    </div>
  );
};

export default AppointmentDatesSelectButton;
